const PROFILE_KEY = 'user_profile_ayoolavue'
const TOKEN_KEY = 'access_token_ayoolavue'
const REFRESH_TOKEN_KEY = 'refresh_token_ayoolavue'




/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
**/
const TokenService = {
    getToken() {
        //localStorage.setItem(TOKEN_KEY, "")
        return localStorage.getItem(TOKEN_KEY)
    },
    getRoles() {
        var jwtDecode = require('jwt-decode');
        if (localStorage.getItem(TOKEN_KEY)) {
            var decoded = jwtDecode(localStorage.getItem(TOKEN_KEY));

            return decoded.role;
        }
        return "";
    },
    saveToken(accessToken) {
        localStorage.setItem(TOKEN_KEY, accessToken)
    },

    removeToken() {
        localStorage.removeItem(TOKEN_KEY)
    },

    getRefreshToken() {
        return localStorage.getItem(REFRESH_TOKEN_KEY)
    },

    saveRefreshToken(refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
    },

    removeRefreshToken() {
        localStorage.removeItem(REFRESH_TOKEN_KEY)
    },
    getUser() {
        return localStorage.getItem(USER_ID)
    },

    saveUser(user) {
        localStorage.setItem(USER_ID, user)
    },

    removeUser() {
        localStorage.removeItem(USER_ID)
    },



}

const ProfileService = {
    getProfile() {
        return localStorage.getItem(PROFILE_KEY)
    },

    saveProfile(profile) {
        localStorage.setItem(PROFILE_KEY, profile)
    },

    removeProfile() {
        localStorage.removeItem(PROFILE_KEY)
    }

}





export { TokenService, ProfileService }